import { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import type { MatchItem } from "../types";

export function Matches({ onOpen }: { onOpen(match: MatchItem): void }) {
  const [error, setError] = useState(false);
  const [items, setItems] = useState<MatchItem[] | null>(null);

  const load = useCallback(async () => {
    setError(false);
    setItems(null);
    try {
      const result = await api<{ matches: MatchItem[] }>("/v1/matches");
      setItems(result.matches);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  if (error)
    return (
      <section className="empty-state page-empty" role="alert">
        <h2>Не удалось загрузить мэтчи</h2>
        <p>Проверьте соединение и повторите попытку.</p>
        <button type="button" className="secondary-button" onClick={() => void load()}>
          Повторить
        </button>
      </section>
    );

  if (!items) return <div className="list-skeleton" />;

  if (items.length === 0)
    return (
      <section className="empty-state page-empty">
        <div className="empty-symbol">♡</div>
        <h2>Мэтчей пока нет</h2>
        <p>Когда симпатия станет взаимной, человек появится здесь.</p>
      </section>
    );

  return (
    <section className="content-page matches-page">
      <div className="section-heading page-heading">
        <span className="eyebrow">Взаимно</span>
        <h1>Мэтчи</h1>
        <p>Люди, которым вы понравились друг другу.</p>
      </div>

      <div className="match-grid">
        {items.map((match, index) => (
          <button
            type="button"
            className="match-card"
            key={match.id}
            style={{ animationDelay: `${Math.min(index, 8) * 35}ms` }}
            onClick={() => onOpen(match)}
          >
            {match.user.photoUrl ? <img src={match.user.photoUrl} alt="" /> : <span className="avatar-fallback" />}
            <span className="match-card-copy">
              <strong>{match.user.displayName}</strong>
              <span>Написать</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
